<template>
    <div class="specialView-container">
        <section class="specialView-image_container okViewMY-color">
            <span class="specialView-image okViewMY-image"></span>
        </section>
        <section class="specialView-info_container ">
            <h2 class="specialView-info_title" > ¡Listo! La solicitud para el estudio de tu hipoteca se ha enviado con éxito</h2>
            <p class="specialView-info_text">Nos pondremos en contacto contigo para que nos faclites más información para elaborar el estudio de tu hipoteca más ajustado a tus necesidades. Posteriormente contactaremos con los principales bancos españoles para encontrar la mejor oferta hipotecaria para ti.</p>
            <div class="okview-action_container ">
                <button class="button primary rounded" @click="goEnd()" >
                    Entendido
                </button>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: 'OKView',
    mounted() {
        window.scrollTo(0, 0);
    },
    methods: {
        goEnd() {
            window.location.href = 'https://myinvestor.es/hipotecas/';
        }
    }
}
</script>

<style scoped>
    .okViewMY-color {
        background: #DFF1ED;
    }
    .okViewMY-image {
        width: 400px;
        height: 400px;
        flex-shrink: 0;
        background: url(../../assets/barras_verde.jpg) #DFF1ED 50% / contain no-repeat;
    }
    .okview-button_container{
        justify-content: center;
        width: 100%;
    }
    /* MOVIL */
    @media (max-width: 768px) {
        .okviewMY-image {
            width: 240px;
        }
        .okview-action_container {
            width: 100%;
        } 
    }

</style>
